<template>
  <div>
    <div class="">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="Production Date"
                  label-for="datepicker-1"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-1"
                    v-model="FromDate"
                    placeholder="Choose a date"
                    local="en"
                    @change="getGraphData()"
                     @input="getGraphData()"
                    required
                  ></b-form-datepicker>
                </b-form-group>
              </div>

              <!-- <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="End Date"
                  label-for="datepicker-2"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-2"
                    v-model="EndDate"
                    placeholder="Choose a date"
                    local="en"
                    @input="getProductionReport()"
                    size="sm"
                    required
                    :min="StartDate"
                  ></b-form-datepicker>
                </b-form-group>
              </div> -->

              <!---ADD BUTTON-->
              <!-- <div class="custom-btn">
                <b-form-group
                  label="Start Time"
                  label-for="Start Time"
                  autocomplete="off"
                >
                  <b-form-select
                    v-model="SelectedStartTimeSlot"
                    :options="timeSlots"
                    value-field="id"
                    text-field="timeSlot"
                    required
                    size="sm"
                    @change="getTimeWiseProductions"
                  >
                    <b-form-select-option :value="null" disabled hidden
                      >Select Start Time</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </div> -->

             
              <!-- <div class="custom-btn">
                <div class="custom-icon icon">
                  <span style="font-weight: 300; font-size: 15px">|</span>
                </div>
              </div> -->

              <!-- <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="End Time"
                  label-for="End Time"
                  autocomplete="off"
                >
                  <b-form-select
                    v-model="SelectedEndTimeSlot"
                    :options="timeSlots"
                    value-field="id"
                    text-field="timeSlot"
                    required
                    size="sm"
                    @change="GetEndTimeWiseProductions"
                  >
                    <b-form-select-option :value="null" disabled hidden
                      >Select End Time</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="collapse" id="filterSection">
        <div class="card card-body custom-filter-body">
          <div class="custom-filter-wrap">
            <div class="custom-row d-flex justify-content-between">
              

              <div class="custom-filter-column">
                <b-form inline>
                

                  <b-form-group
                    label=""
                    label-for="datepicker-2"
                    autocomplete="off"
                    style="margin-bottom: 0px;"
                  >
                    <b-form-datepicker
                      id="datepicker-2"
                      v-model="FromDate"
                      @input="getWheatReceives()"
                      placeholder="Choose Start Date"
                      local="en"
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                  
                  <b-form-group
                    label=""
                    style="margin-bottom: 0px;"
                    label-for="datepicker-1"
                    autocomplete="off"
                  >
                    <b-form-datepicker
                      id="datepicker-1"
                      v-model="ToDate"
                      placeholder="Choose End Date"
                      @input="getWheatReceives()"
                      local="en"
                    ></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                 
                  <b-form-select
                    v-model="IsGovt"
                    :options="statusOptions"
                    class="class-dropdown"
                    @change="getWheatReceives()"
                  ></b-form-select>
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                 
                  <b-form-select
                    v-model="IsNonInventory"
                    :options="inventoryOptions"
                    class="class-dropdown"
                    @change="getWheatReceives()"
                  ></b-form-select>

                
  
                </b-form>
              </div>

              <div class="custom-filter-column">
                <b-form inline>
                  <select
                    class="mb-2 mr-sm-2 mb-sm-0 custom-select-option form-control"
                    v-model="wheatTypeId"
                    @change="getWheatReceives"
                  >
                    <option value="null">Select Wheat Type (All)</option>
                    <option
                      v-for="option in wheatTypes"
                      :key="option.id"
                      :value="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="custom-accordion-separator">
      <div class="custom-separator"></div>
    </div>
    <div style="width:70%;margin:auto;margin-top:5%;">
      <BarGraph
        v-if="graphData != null"
        :chartData="graphData"
        :options="graphOptions"
      ></BarGraph>
    </div>
    <Spinner
      v-if="isLoading"
      message="Loading..."
      size="medium"
      line-fg-color="rgb(222 224 219"
      line-bg-color="rgb(68 66 62)"
    >
    </Spinner>
    <div v-if="graphData == null && !isLoading" style="text-align:center">
      <b style="color:red">No data found</b>
    </div>

    <Toaster ref="toaster" />
  </div>
</template>
<script>
// import VueCharts from 'vue-chartjs'
import BarGraph from "./bar-graph";
import axios from "axios";
import Toaster from "../toaster";
import Spinner from "vue-simple-spinner";
export default {
  name: "ProductionBranPercentageGraph",
  components: {
    BarGraph,
    Spinner,
    Toaster,
  },
  data() {
    return {
      moduleName: "Production Bran Percentage Graphical Report",
      graphData: null,
      graphOptions: Object,
      FromDate: new Date(),
      ToDate: new Date(),
      isLoading: true,
    };
  },
  mounted() {
    this.FromDate = new Date(
      this.FromDate.getFullYear(),
      this.FromDate.getMonth(),
      1,
      this.FromDate.getHours()
    );
    // this.ToDate = new Date(
    //   this.ToDate.getFullYear(),
    //   this.ToDate.getMonth() + 1,
    //   0,
    //   this.ToDate.getHours()
    // );
    this.graphOptions = {
      responsive: true,
      maintainAspectRatio: false,
      title: { display: true, text: "Production Bran Percentage Bar Chart" },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: function(label) {
                return label.toLocaleString() + " %";
              },
            },
          },
        ],
        xAxes: [{}],
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function(tooltipItem) {
            return "Bran Percentage: " + tooltipItem.yLabel.toLocaleString();
          },
        },
      },
    };
    this.getGraphData();
  },
  methods: {
    getGraphData() {
      this.isLoading = true;
      this.graphData = null;
      axios
        .post("/productionreport/GetProductionBranPercentageData", {
          FromDate: this.FromDate,
          ToDate: this.ToDate,
          CompanyId: this.$auth.user().companyId,
          Year:null,
          Month:null,
          StartTimeId:null,
          EndTimeId:null
        })
        .then((res) => {
          //   console.log(res)
          this.isLoading = false;
          if (res.data.status == 1) {
            this.graphData = res.data.data;
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
          } else {
            this.graphData = null;
          }
        });
    },
  },
};
</script>

<style scoped>
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
select#class-dropdown {
  width: 80%;
  margin-left: 16%;
}
.custom-row {
  overflow: visible !important;
}
.form-group {
    margin-bottom: 0.4rem;
}
.nav-tabs{
    font-size: 22px !important;
    border-bottom: none !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    border-bottom: 2px solid transparent !important;
}
.b-form-btn-label-control.form-control {
    width: 272px;
}
</style>

